<template>
    <div class="w-screen p-4 bg-white rounded-lg shadow-lg sm:w-1/2">
        <h3 class="text-xl font-semibold text-gray-700">
            {{ slides.slides[activeSlide].title }}
        </h3>
        <div class="mt-6">
            <img v-if="slides.slides[activeSlide].img" :src="slides.slides[activeSlide].img" alt="" class="w-full h-auto mr-4 rounded-lg">
            <div class="mt-6 text-center">
                <span class="text-lg text-gray-500">
                    {{ slides.slides[activeSlide].description }}
                </span>
            </div>
        </div>
        <div v-if="slides.slides[activeSlide].actions" class="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <a
                v-for="(action) in slides.slides[activeSlide].actions"
                :key="action.label"
                :href="action.route"
                class="col-span-1 py-4 mt-4 text-center rounded-lg shadow-lg bg-gray-50 hover:bg-gray-100"
            >
                <span  class="w-full">
                    {{ action.label }}
                </span>
            </a>
        </div>
        <div class="flex justify-between mt-8">
            <button @click="previousSlide" v-if="activeSlide > 0" class="rounded-full bg-mti-blue px-3.5 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mti-blue">Previous</button>
            <button @click="nextSlide" class="rounded-full justify-self-end bg-mti-blue px-3.5 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mti-blue">Next</button>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        slides: {
            type: [Array, Object],
            required: true,
        }
    },
    data() {
        return {
            activeSlide: 0,
        }
    },
    methods: {
        nextSlide() {
            this.activeSlide = this.activeSlide + 1;
        },
        previousSlide(){
            this.activeSlide = this.activeSlide - 1;
        }
    }
}
</script>
